/**
 * Builds the URL given matching parameters.
 *
 * @param  {String} url: base URL
 * @param  {Object} params: object with parameters to be replaced in the URL
 * @return {String}
 */
export default function buildUrl(url, params) {
  let p;

  for (p in params) {
    url = url.replace(`:${p}`, params[p]);
  }

  return url;
}
